export enum GroupFolderTreeLoadStateEnum {
    Uninitialized,
    Loading,
    Loaded,
    ErrorLoading
}
